import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Restrictions } from 'shared/api/MyTicketsModel'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  restrictions: Restrictions[] | undefined
}

export const ReminderInfo = ({ restrictions }: Props) => {
  const { t } = useTranslation()
  return (
    <div className={s.reminderInfo}>
      <p className={clsx('bold-17', s.reminderTitle)}>{t('reminder')}</p>
      <div className={s.reminderList}>
        {restrictions?.map((item) => (
          <div className={s.reminderItem}>
            <AppIcon
              id={AllIcons.INFO_CIRCLE}
              className={s.icon}
              color={item.color}
            />

            <p className={clsx('regular-12', s.reminderText)}>{item.caption}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
